<template>
  <a @click="$emit('close-transport')">
    <img v-if="transport.access"
         class="icon-pdf"
         :src="iconPath('v_accept.svg')"
         alt="Разрешить доступ"/>
    <img v-else
         :src="iconPath('v_denied.svg')"
         class="icon-pdf"
         alt="Запретить доступ"/>
    {{ transport.access ? 'Разрешить доступ' : 'Запретить доступ' }}
  </a>
</template>

<script>
export default {
  name: 'GiveTransportAccessButton',

  props: {
    visitor: {
      type: Object
    },
    transport: {
      type: Object
    }
  },

  methods: {
    iconPath(baseName) {
      return require('@/common/assets/img/icons/menuVisitor/' + baseName)
    }
  }

}
</script>

<style scoped>

</style>
